"use strict";

/* Theme-level Hunt variant access. Checkout/API enforcement belongs in an app Function. */
(function () {
  'use strict';

  const policy = {
    hasAccess: state => state.customerMember === true || state.promotionalPeriod === true || state.cartMembership === true,
    locked: (variant, state, wholeProduct = false) => (wholeProduct || variant?.membersOnly === true) && !policy.hasAccess(state)
  };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = policy;
    return;
  }
  const boot = () => {
    const initial = document.querySelector('[data-hunt-cart-state]');
    if (!initial || initial.dataset.initialized === 'true') return;
    initial.dataset.initialized = 'true';
    let state = JSON.parse(initial.textContent);
    const controllers = new Map();
    function mount() {
      document.querySelectorAll('[data-hunt-variant-data]').forEach(node => {
        if (controllers.has(node)) return;
        const config = JSON.parse(node.textContent);
        const form = document.getElementById(config.formId);
        if (!form) return;
        const variants = new Map(config.variants.map(v => [v.id, v]));
        const modal = document.getElementById(config.modalFormId);
        const section = form.closest('.shopify-section');
        const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: config.currency
        }).format(cents / 100);
        const current = () => variants.get(form.querySelector('[name="id"]').value);
        const forms = () => [form, modal].filter(Boolean);
        const buttonMarkup = new WeakMap();
        forms().forEach(target => target.querySelectorAll('[data-hunt-variant-submit]').forEach(button => {
          if (current()?.available) buttonMarkup.set(button, button.innerHTML);
        }));
        const sync = () => {
          const variant = current();
          if (!variant) return;
          const locked = policy.locked(variant, state, config.wholeProductMemberOnly);
          const frequency = form.querySelector('[id$="-sellingPlanOptions"]');
          const subscription = form.querySelector('.rtnu-single-option--purchaseType-subscription');
          const oneTime = form.querySelector('.rtnu-single-option--purchaseType-one-time');
          const planInput = form.querySelector('[id$="-sellingPlan"]');
          const supported = variant.plans || [];
          if (frequency) {
            Array.from(frequency.options).forEach(option => {
              option.disabled = !supported.some(plan => plan.id === option.value);
            });
            if (frequency.selectedOptions[0]?.disabled) frequency.value = Array.from(frequency.options).find(option => !option.disabled)?.value || '';
          }
          const plan = supported.find(plan => plan.id === frequency?.value);
          if (subscription) {
            subscription.disabled = !plan;
            if (!plan && subscription.checked && oneTime) oneTime.click();
          }
          const subscribed = !!(subscription?.checked && plan);
          if (planInput) {
            planInput.name = subscribed ? 'selling_plan' : '';
            if (plan) planInput.value = plan.id;
          }
          const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
          const price = subscribed ? plan.price : variant.price;
          const cashback = form.querySelector('[data-variant-cashback]');
          if (cashback) cashback.textContent = money(Math.floor(price * quantity * 0.05));
          const ouncePrice = form.querySelector('.quantity-oz-price');
          if (ouncePrice && Number(variant.ounces) > 0) {
            ouncePrice.dataset.ounce = variant.ounces;
            ouncePrice.textContent = `${money(price / variant.ounces)} / per oz (${variant.ounces} oz)`;
          }
          form.querySelectorAll('.rtnu-single-option__price--onetime').forEach(node => {
            const values = node.querySelectorAll('div:not(.compare-at-price)');
            if (values.length) values[values.length - 1].textContent = money(variant.price * quantity);
            const compare = node.querySelector('.compare-at-price');
            if (compare) {
              compare.hidden = !(variant.compareAt > variant.price);
              compare.textContent = money(variant.compareAt * quantity);
            }
          });
          const subscriptionPrice = form.querySelector('.rtnu-single-option__price--subscription');
          if (subscriptionPrice && plan) {
            subscriptionPrice.querySelector('del').textContent = money(variant.price * quantity);
            subscriptionPrice.querySelector('div').textContent = money(plan.price * quantity);
          }
          const oneTimeLabel = form.querySelector('.purchaseType-one-time');
          if (oneTimeLabel) oneTimeLabel.dataset.price = money(variant.price);
          const subscriptionLabel = form.querySelector('.purchaseType-subscription');
          if (subscriptionLabel && plan) subscriptionLabel.dataset.subPrice = money(plan.price);
          if (modal) {
            const modalPlan = modal.querySelector('[id$="-sellingPlan"]');
            if (modalPlan) {
              modalPlan.name = subscribed ? 'selling_plan' : '';
              modalPlan.value = plan?.id || '';
            }
            modal.querySelector('[name="quantity"]').value = quantity;
          }
          form.querySelectorAll('[data-hunt-members-only]').forEach(option => {
            const v = variants.get(option.dataset.id);
            option.setAttribute('aria-disabled', String(!v?.available));
          });
          forms().forEach(target => {
            target.dataset.huntVariantLocked = String(locked);
            target.querySelector('[name="id"]').value = variant.id;
            target.querySelectorAll('[data-hunt-variant-submit]').forEach(button => {
              if (!variant.available) {
                if (!button.classList.contains('rtnu-btn--sold-out')) buttonMarkup.set(button, button.innerHTML);
                button.textContent = window.variantStrings?.soldOut || 'Sold Out';
              } else if (button.classList.contains('rtnu-btn--sold-out')) {
                button.innerHTML = buttonMarkup.get(button) || '<span></span>';
                if (!buttonMarkup.has(button)) button.querySelector('span').textContent = window.variantStrings?.addToCart || 'Add to Cart';
              }
              button.disabled = locked || !variant.available;
              button.classList.toggle('rtnu-btn--sold-out', !variant.available);
            });
            const message = target.querySelector('[data-hunt-variant-notice]');
            if (message) message.hidden = !locked;
          });
          section?.querySelectorAll('.rtnu-product__price-w-oz__price').forEach(node => {
            node.textContent = money(price * quantity);
          });
          section?.querySelectorAll('.rtnu-product__price-w-oz__oz').forEach(node => {
            node.hidden = !(Number(variant.ounces) > 0);
            if (!node.hidden) node.querySelector('span').textContent = money(price / Number(variant.ounces));
          });
        };
        // Capture runs before GrowAOV/Boost and the legacy selector handlers.
        const guard = event => {
          const variant = current();
          if (!variant || !variant.available || policy.locked(variant, state, config.wholeProductMemberOnly)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            sync();
          }
        };
        forms().forEach(target => {
          target.addEventListener('submit', guard, true);
          target.addEventListener('click', event => {
            if (event.target.closest('[data-hunt-variant-submit]')) guard(event);
            if (event.target.closest('a[href="#hunt-membership-upsell"]')) {
              event.preventDefault();
              if (target === modal) window.Fancybox?.close();
              const upsell = document.getElementById('hunt-membership-upsell');
              upsell?.scrollIntoView({
                block: 'start',
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
              });
              upsell?.querySelector('button')?.focus({
                preventScroll: true
              });
            }
          }, true);
        });
        form.addEventListener('click', event => {
          // Legacy purchase-type and quantity listeners finish before synchronization.
          queueMicrotask(sync);
        }, true);
        form.addEventListener('cs:variant:change', sync);
        form.addEventListener('change', sync);
        controllers.set(node, {
          sync,
          variants
        });
        sync();
      });
    }
    function apply(next) {
      state = next;
      controllers.forEach(controller => controller.sync());
    }
    document.addEventListener('cs:membership:statechange', event => {
      const cart = event.detail?.cartData;
      if (!cart?.items) return;
      apply({
        ...state,
        cartMembership: cart.items.some(item => String(item.variant_id) === '44168397324528')
      });
    });
    document.addEventListener('shopify:section:load', mount);
    mount();
    apply(state);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);else boot();
})();